import { createStore, compose, applyMiddleware } from 'redux';

export default (reducers, middlewares) => {
  const enhancers = [applyMiddleware(...middlewares)];

  if (typeof console !== 'undefined' && console.tron && typeof console.tron.createEnhancer === 'function') {
    enhancers.push(console.tron.createEnhancer());
  }

  const composeEnhancers =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  return createStore(reducers, composeEnhancers(...enhancers));
};
